//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { logoPlaceholderUrl, PlayIcon } from '@cmp/images';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { isTouchEnabled } from '@helpers/device';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Slideshow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImage: null,
      currentVideo: null,
    };
  }

  componentDidMount() {
    this.setupCurrentImageIfNeeded();
  }

  componentDidUpdate() {
    this.setupCurrentImageIfNeeded();
  }

  setupCurrentImageIfNeeded() {
    const { currentImage, currentVideo } = this.state;
    const { images } = this.props;

    if (!currentImage && !currentVideo && images.length > 0) {
      this.setState({ currentImage: images[0] });
    }
  }

  allImagesComponent() {
    const { videos, images, i18n } = this.props;
    if (!images) return '';

    return (
      <div className={styles.AllImages}>
        {images.map((image) => (
          <div className={styles.ThumbnailWrapper} key={image.id}>
            <img
              className={styles.Thumbnail}
              src={image.src}
              alt={t('dashboard_Product_slideshow_ThumbnailImage')}
              onMouseOver={() => {
                if (!isTouchEnabled()) {
                  this.setState({ currentImage: image, currentVideo: null });
                }
              }}
              onClick={() => {
                if (isTouchEnabled()) {
                  this.setState({ currentImage: image, currentVideo: null });
                }
              }}
            />
          </div>
        ))}
        {videos &&
          videos.map((video) => {
            if (!video.isValid()) return '';

            return (
              <div
                className={classNames(styles.Thumbnail, styles.VideoThumnail)}
                key={video.id()}
                onMouseOver={() => {
                  if (!isTouchEnabled()) {
                    this.setState({ currentImage: null, currentVideo: video });
                  }
                }}
                onClick={() => {
                  if (isTouchEnabled()) {
                    this.setState({ currentImage: null, currentVideo: video });
                  } else {
                    this.pushMedia(null, video.videoUrl);
                  }
                }}
              >
                <div className={styles.Overlay}>
                  <PlayIcon className={styles.PlayIcon} />
                </div>
                <img src={video.thumbnailUrl() || logoPlaceholderUrl(i18n)} />
              </div>
            );
          })}
      </div>
    );
  }

  videoPreviewComponent() {
    const { currentVideo } = this.state;
    const { history, i18n } = this.props;
    const videoPreviewClasses = classNames(styles.Main, styles.VideoPreview);

    return (
      <div className={videoPreviewClasses}>
        <img
          src={currentVideo.thumbnailUrl() || logoPlaceholderUrl(i18n)}
          className={styles.Current}
          onClick={() => this.pushMedia(null, currentVideo.videoUrl)}
        />
        <PlayIcon className={styles.PlayIcon} />
      </div>
    );
  }

  mainImageComponent() {
    const { currentImage } = this.state;
    const { t, i18n } = this.props;

    return (
      <div className={styles.CurrentSelectionWrapper}>
        <div className={styles.Main}>
          <img
            src={(currentImage && currentImage.src) || logoPlaceholderUrl(i18n)}
            className={styles.Current}
            onClick={() => this.pushMedia(currentImage && currentImage.src)}
            alt={t('dashboard_Product_Slideshow_CurrentImage')}
          />
        </div>
        <p className={styles.ClickToZoomText}>
          {t('dashboard_Product_Zoom_Text')}
        </p>
      </div>
    );
  }

  pushMedia(imageUrl, videoUrl) {
    const { history } = this.props;

    history.push({
      pathname: '/media',
      state: {
        modal: true,
        from: history.location,
        imageUrl,
        videoUrl,
      },
    });
  }

  render() {
    const { currentImage, currentVideo } = this.state;
    const { className } = this.props;
    const componentClasses = classNames(styles.Slideshow, {
      [className]: className,
    });

    return (
      <div className={componentClasses}>
        {currentImage && this.mainImageComponent()}
        {currentVideo && this.videoPreviewComponent()}
        {this.allImagesComponent()}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withRouter(withTranslation()(Slideshow));
